import type { FC } from 'react';

import { Icon } from '@trend-dev/ui-libs-icons';

import styles from './styles.module.scss';

const Loader: FC = () => {
    return (
        <div className={styles.loader}>
            <Icon name='LoaderBold_60' />
        </div>
    );
};

export default Loader;
